RESET_PAYMENT_METHODS